module.exports = __webpack_public_path__ + "static/img/accordion1.8f11fae.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/feature/accordion1.png
// module id = OVBi
// module chunks = 7